import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Skeleton } from '@mui/material';
import { UserCard } from 'components/user/model/User';
import { LoadingTypography } from 'lib/LoadingTypography';
import { PaymentMethodIcon } from 'lib/PaymentMethodIcon';

const StyledLoadingTypography = styled(LoadingTypography)(() => ({
    fontSize: '13px',
    fontWeight: 700
}));

const StyledIconBox = styled(Box)(() => ({
    height: '27px',
    width: '42px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}));

interface PaymentMethodItemProps {
    card?: UserCard;
    type: string;
    loading?: boolean;
}

export const PaymentMethodItem: React.FC<React.PropsWithChildren<PaymentMethodItemProps>> = ({
    card,
    type,
    loading
}) => {
    const { t } = useTranslation();

    const content = React.useMemo(() => {
        switch (type) {
            case 'GOOGLEPAY':
                return t('PAYMENT_TYPE_GOOGLE_PAY');
            case 'APPLEPAY':
                return t('PAYMENT_TYPE_APPLE_PAY');
            default:
                return card ? `**** **** **** ${card.last4}` : null;
        }
    }, [card, t, type]);
    if (loading) {
        return (
            <Box display="flex" alignItems="center">
                <StyledIconBox marginRight={1} display="flex" alignItems="center">
                    <Skeleton variant="rectangular" width="100%" />
                </StyledIconBox>
                <StyledLoadingTypography loading width={100} />
            </Box>
        );
    }
    return (
        <Box display="flex" alignItems="center">
            <StyledIconBox marginRight={1} display="flex" alignItems="center">
                <PaymentMethodIcon width="100%" type={type} />
            </StyledIconBox>
            <Typography sx={{ fontSize: '13px', fontWeight: 700 }}>{content}</Typography>
        </Box>
    );
};
